import { render } from "./SidenavCollapse.vue?vue&type=template&id=fc96549c&scoped=true"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import "./SidenavCollapse.vue?vue&type=style&index=0&id=fc96549c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc96549c"]])

export default __exports__